// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3awcG","largestCol":"styles_largestCol__2OGJj","smallestCol":"styles_smallestCol__6QAhT"};